__turbopack_context__.v({
  "textLink": "tfKWWa_textLink",
  "titleFont": "tfKWWa_titleFont",
});
